const PUBLISH_TYPE = {
  ALL_REVIEWED_LOTS: 'all_reviewed_lots',
  ALL_LOTS: 'all_lots',
  ALL_LOTS_WITH_MEDIUM_PARSER_CONFIDENCE: 'all_lots_with_medium_parser_confidence',
};

export { PUBLISH_TYPE };
